// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import store from '@/store'
import router from '@/router'
import ApiService from '@/common/api.service'
import 'expose-loader?$!expose-loader?jQuery!jquery'
import 'bootstrap'
import '../static/js/bootstrap.bundle.js'
import { BootstrapVue, ModalPlugin, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'


Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

Vue.use(BootstrapVue)
Vue.use(ModalPlugin)
Vue.use(IconsPlugin)
Vue.config.productionTip = false
Vue.filter('comma', function (value) {
  if (!value) return ''
  return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
})

ApiService.init()
ApiService.setHeader()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js